import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/workspace/src/layouts/blogPost.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Starswap Labs — a software development studio that contributes to the Starswap Protocol — is proud to play a part in creating a better, more equitable financial system. One of Starswap Labs’ contributions is the portal it provides at app.starswap.xyz — an open source interface — for reliable, trustworthy interaction with the Starswap Protocol.`}</p>
    <p>{`To continue to innovate and provide this tool for the Starswap community, we monitor the evolving regulatory landscape. Today, consistent with actions taken by other DeFi interfaces, we have taken the decision to restrict access to certain tokens through app.starswap.xyz. These tokens have always represented a very small portion of overall volume on the Starswap Protocol — a full list is available `}<a parentName="p" {...{
        "href": "https://github.com/Starswap/Starswap-interface/tree/main/src/constants/tokenLists/unsupported.tokenlist.json"
      }}>{`here`}</a>{`.`}</p>
    <p>{`Importantly, the Starswap Protocol — unlike the interface — is a set of autonomous, decentralized, and immutable smart contracts. It provides unrestricted access to anyone with an Internet connection. Similarly, this action has no impact on the Starswap Interface code, which remains open source, or the many other portals or locally run instances used to access the Starswap Protocol.`}</p>
    <p>{`Moving forward, we will continue to develop products and contribute to the Starswap Protocol, in a way that is consistent with the broader DeFi industry’s values — to provide safe, transparent, and robust financial infrastructure that can empower users around the world.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      